export const ABOUT_LOOK_OPTIONS = [
  {
    id: 'yes',
    title: 'Yes, I have a vision',
  },
  {
    id: 'no',
    title: 'No, keep her authentic',
  },
] as const;

export const ABOUT_LOOK_OPTIONS_MALE = [
  {
    id: 'yes',
    title: 'Yes, I have a vision',
  },
  {
    id: 'no',
    title: 'No, keep him authentic',
  },
] as const;
